import { homedir } from "node:os";
import { join } from "node:path";
import { resolveInstalledNodeScriptLaunchCandidates, resolveInstalledNodeScriptLaunchContract, resolveLaunchCandidatesAfterVerification, verifyCliLaunchContract, } from "@openmeld/adapter-core";
const DEFAULT_CLAUDE_CODE_COMMAND = "claude";
export async function resolveInstalledClaudeCodeLaunchCandidates(input) {
    const installedCandidates = await resolveInstalledNodeScriptLaunchCandidates({
        additionalCommandDirectories: resolveClaudeCodeCommandDirectories(),
        commandName: DEFAULT_CLAUDE_CODE_COMMAND,
        configuredCommand: normalizeOptionalText(process.env.OPENMELD_DAEMON_RUNTIME_CLAUDE_CODE_BIN),
        displayName: "Claude Code",
        preferredLaunchContract: input?.preferredLaunchContract,
    });
    if (!installedCandidates.ok) {
        return installedCandidates;
    }
    const candidates = await resolveLaunchCandidatesAfterVerification({
        candidates: installedCandidates.candidates,
        verify: async (candidate) => await verifyClaudeCodeLaunchContract({
            launchContract: candidate.launchContract,
            timeoutMs: input?.timeoutMs,
        }),
    });
    if (candidates.length === 0) {
        return {
            errorMessage: "Claude Code is installed, but OpenMeld can't start it on this device.",
            reason: "not_launchable",
            ok: false,
        };
    }
    return {
        candidates,
        ok: true,
    };
}
export async function resolveInstalledClaudeCodeLaunchContract() {
    return await resolveInstalledNodeScriptLaunchContract({
        additionalCommandDirectories: resolveClaudeCodeCommandDirectories(),
        commandName: DEFAULT_CLAUDE_CODE_COMMAND,
        configuredCommand: normalizeOptionalText(process.env.OPENMELD_DAEMON_RUNTIME_CLAUDE_CODE_BIN),
        displayName: "Claude Code",
    });
}
export async function verifyClaudeCodeLaunchContract(input) {
    return await verifyCliLaunchContract({
        cwd: input.cwd ?? process.cwd(),
        displayName: "Claude Code",
        launchContract: input.launchContract,
        probeArgs: ["--version"],
        timeoutMs: input.timeoutMs ?? resolveClaudeCodeTimeoutMs(),
    });
}
export function resolveClaudeCodeTimeoutMs() {
    // Explicit watchdog override only. Normal OpenMeld Wake execution has no fixed
    // Claude Code process timeout.
    const raw = normalizeOptionalText(process.env.OPENMELD_DAEMON_RUNTIME_REQUEST_TIMEOUT_MS);
    if (!raw) {
        return null;
    }
    const parsed = Number.parseInt(raw, 10);
    if (!Number.isFinite(parsed) || parsed <= 0) {
        return null;
    }
    return parsed;
}
function resolveClaudeCodeCommandDirectories() {
    return [
        join(normalizeOptionalText(process.env.HOME) ?? homedir(), ".local", "bin"),
    ];
}
function normalizeOptionalText(value) {
    const normalized = String(value ?? "").trim();
    return normalized.length > 0 ? normalized : null;
}
